'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBlockWithRibbon, iconBlockWithRibbonTag } from '@ni/nimble-components/dist/esm/icons/block-with-ribbon';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBlockWithRibbon };
export { iconBlockWithRibbonTag };
export const NimbleIconBlockWithRibbon = wrap(IconBlockWithRibbon);